import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

const ACK_KEY = "stellar_cookie_ack_v1";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(ACK_KEY)) setShow(true);
    } catch {}
  }, []);

  const accept = () => {
    try { localStorage.setItem(ACK_KEY, new Date().toISOString()); } catch {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[60] p-3 sm:p-4"
    >
      <div className="mx-auto max-w-3xl bg-[#141738]/95 backdrop-blur-xl border border-[#252B5C] rounded-2xl p-4 shadow-[0_0_30px_rgba(0,0,0,0.4)] flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <Cookie className="w-5 h-5 text-cyan-300 shrink-0 mt-0.5" />
          <p className="text-slate-300 text-sm leading-snug">
            Stellar Steps uses only essential storage to keep you signed in and remember your ship —
            no advertising and no third-party tracking. See our{" "}
            <Link to="/privacy" data-testid="cookie-privacy-link" className="text-cyan-300 underline hover:text-cyan-200">Privacy Policy</Link>{" "}
            and{" "}
            <Link to="/terms" data-testid="cookie-terms-link" className="text-cyan-300 underline hover:text-cyan-200">Terms of Use</Link>.
          </p>
        </div>
        <Button
          data-testid="cookie-accept-btn"
          onClick={accept}
          className="bg-cyan-500 hover:bg-cyan-600 text-[#0B0D1B] font-heading font-bold min-h-[44px] px-6 w-full sm:w-auto shrink-0"
        >
          Got it
        </Button>
      </div>
    </div>
  );
};

export default CookieBanner;
